module.exports = __webpack_public_path__ + "static/img/02.807e8ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/04/02.jpg
// module id = 4NsD
// module chunks = 1